import { gql } from '@apollo/client';

export const ARCHIVE_TOPIC = gql`
  mutation ArchiveTopic($id: ID!) {
    archiveTopic(id: $id) {
      id
      name
      publicId
      archivedAt
    }
  }
`;

export const CREATE_CHECKOUT_SESSION = gql`
  mutation CreateCheckoutSession($spaceSlug: String!) {
    createCheckoutSession(spaceSlug: $spaceSlug)
  }
`;

export const CREATE_COMMENT = gql`
  mutation CreateComment($topicId: ID!, $body: String!) {
    createComment(topicId: $topicId, body: $body) {
      id
      body
      author {
        id
        name
        avatarUrl
      }
      lastEdited
      publicId
      createdAt
    }
  }
`;

export const CREATE_PORTAL_SESSION = gql`
  mutation CreatePortalSession($spaceSlug: String!) {
    createPortalSession(spaceSlug: $spaceSlug)
  }
`;

export const CREATE_SPACE = gql`
  mutation CreateSpace($name: String!, $slug: String!) {
    createSpace(name: $name, slug: $slug) {
      id
      name
      slug
    }
  }
`;

export const CREATE_TAG = gql`
  mutation CreateTag($name: String!, $spaceSlug: String!) {
    createTag(name: $name, spaceSlug: $spaceSlug) {
      id
      name
    }
  }
`;

export const CREATE_TOPIC = gql`
  mutation CreateTopic(
    $name: String!
    $body: String!
    $spaceId: ID!
    $tags: [ID!]
  ) {
    createTopic(name: $name, body: $body, spaceId: $spaceId, tags: $tags) {
      id
      name
      state
      author {
        id
        name
        avatarUrl
      }
      assignee {
        id
        name
        avatarUrl
      }
      tags {
        id
        name
      }
      createdAt
      publicId
      isPinned
    }
  }
`;

export const DELETE_COMMENT = gql`
  mutation DeleteComment($id: ID!) {
    deleteComment(id: $id) {
      id
    }
  }
`;

export const DELETE_SESSION = gql`
  mutation DeleteSession($id: ID!) {
    deleteSession(id: $id) {
      id
    }
  }
`;

export const DELETE_SPACE = gql`
  mutation DeleteSpace($slug: String!) {
    deleteSpace(slug: $slug) {
      id
      slug
    }
  }
`;

export const DELETE_SPACE_USER = gql`
  mutation DeleteSpaceMember($spaceSlug: String!, $userId: ID!) {
    deleteSpaceMember(spaceSlug: $spaceSlug, userId: $userId) {
      spaceId
      user {
        id
      }
    }
  }
`;

export const DELETE_TAG = gql`
  mutation DeleteTag($id: ID!) {
    deleteTag(id: $id) {
      id
    }
  }
`;

export const DELETE_TOPIC = gql`
  mutation DeleteTopic($id: ID!) {
    deleteTopic(id: $id) {
      id
    }
  }
`;

export const DELETE_VIEWER = gql`
  mutation DeleteViewer {
    deleteViewer {
      id
    }
  }
`;

export const JOIN_SPACE = gql`
  mutation JoinSpace($joinCode: String!) {
    joinSpace(joinCode: $joinCode) {
      id
      name
      slug
    }
  }
`;

export const LEAVE_SPACE = gql`
  mutation LeaveSpace($slug: String!) {
    leaveSpace(slug: $slug) {
      user {
        id
      }
    }
  }
`;

export const LOGOUT = gql`
  mutation Logout {
    logout
  }
`;

export const PIN_TOPIC = gql`
  mutation PinTopic($id: ID!) {
    pinTopic(id: $id) {
      id
      isPinned
    }
  }
`;

export const RESET_SPACE_JOIN_CODE = gql`
  mutation ResetSpaceJoinCode($slug: String!) {
    resetSpaceJoinCode(slug: $slug) {
      id
      joinCode
    }
  }
`;

export const SEND_EMAIL_CODE = gql`
  mutation SendEmailCode($email: String!) {
    sendEmailCode(email: $email)
  }
`;

export const SEND_LOGIN_CODE = gql`
  mutation SendLoginCode($email: String!) {
    sendLoginCode(email: $email)
  }
`;

export const TOGGLE_EARLY_ACCESS = gql`
  mutation ToggleEarlyAccess($spaceSlug: String!) {
    toggleEarlyAccess(spaceSlug: $spaceSlug) {
      id
      earlyAccess
    }
  }
`;

export const TOGGLE_INVITES = gql`
  mutation ToggleInvites($spaceSlug: String!) {
    toggleInvites(spaceSlug: $spaceSlug) {
      id
      joinCode
    }
  }
`;

export const TOGGLE_NIGHT_MODE = gql`
  mutation ToggleNightMode {
    toggleNightMode {
      id
      nightMode
    }
  }
`;

export const TOGGLE_PUBLIC = gql`
  mutation TogglePublic($spaceSlug: String!) {
    togglePublic(spaceSlug: $spaceSlug) {
      id
      public
    }
  }
`;

export const TRANSFER_OWNERSHIP = gql`
  mutation TransferOwnership($spaceSlug: String!, $ownerId: ID!) {
    transferOwnership(spaceSlug: $spaceSlug, ownerId: $ownerId) {
      id
      ownerId
    }
  }
`;

export const UNARCHIVE_TOPIC = gql`
  mutation UnarchiveTopic($id: ID!) {
    unarchiveTopic(id: $id) {
      id
      name
      state
      author {
        id
        name
      }
      assignee {
        id
        name
      }
      tags {
        id
        name
      }
      createdAt
      publicId
      isPinned
      archivedAt
    }
  }
`;

export const UNPIN_TOPIC = gql`
  mutation UnpinTopic($id: ID!) {
    unpinTopic(id: $id) {
      id
      isPinned
    }
  }
`;

export const UPDATE_COMMENT_BODY = gql`
  mutation UpdateCommentBody($id: ID!, $body: String!) {
    updateCommentBody(id: $id, body: $body) {
      id
      body
      lastEdited
    }
  }
`;

export const UPDATE_SPACE_BANNER = gql`
  mutation UpdateSpaceBanner($id: ID!, $banner: String) {
    updateSpaceBanner(id: $id, banner: $banner) {
      id
      bannerUrl
    }
  }
`;

export const UPDATE_SPACE_ICON = gql`
  mutation UpdateSpaceIcon($id: ID!, $icon: String!) {
    updateSpaceIcon(id: $id, icon: $icon) {
      id
      icon
    }
  }
`;

export const UPDATE_SPACE_NAME = gql`
  mutation UpdateSpaceName($id: ID!, $name: String!) {
    updateSpaceName(id: $id, name: $name) {
      id
      name
    }
  }
`;

export const UPDATE_SPACE_SLUG = gql`
  mutation UpdateSpaceSlug($id: ID!, $slug: String!) {
    updateSpaceSlug(id: $id, slug: $slug) {
      id
      slug
    }
  }
`;

export const UPDATE_SPACE_USER_ROLE = gql`
  mutation UpdateSpaceMemberRole(
    $spaceSlug: String!
    $userId: ID!
    $role: Role!
  ) {
    updateSpaceMemberRole(spaceSlug: $spaceSlug, userId: $userId, role: $role) {
      spaceId
      joinedAt
      role
      user {
        id
        name
        avatarUrl
      }
    }
  }
`;

export const UPDATE_TAG = gql`
  mutation UpdateTag($id: ID!, $name: String!) {
    updateTag(id: $id, name: $name) {
      id
      name
    }
  }
`;

export const UPDATE_TOPIC = gql`
  mutation UpdateTopic($id: ID!, $name: String!, $tags: [ID!]!) {
    updateTopic(id: $id, name: $name, tags: $tags) {
      id
      name
      tags {
        id
        name
      }
    }
  }
`;

export const UPDATE_TOPIC_ASSIGNEE = gql`
  mutation UpdateTopicAssignee($id: ID!, $assigneeId: ID) {
    updateTopicAssignee(id: $id, assigneeId: $assigneeId) {
      id
      assignee {
        id
        name
      }
    }
  }
`;

export const UPDATE_TOPIC_STATE = gql`
  mutation UpdateTopicState($id: ID!, $state: TopicState!) {
    updateTopicState(id: $id, state: $state) {
      id
      state
    }
  }
`;

export const UPDATE_VIEWER_AVATAR = gql`
  mutation UpdateViewerAvatar($avatar: String) {
    updateViewerAvatar(avatar: $avatar) {
      id
      avatarUrl
    }
  }
`;

export const UPDATE_VIEWER_NAME = gql`
  mutation UpdateViewerName($name: String!) {
    updateViewerName(name: $name) {
      id
      name
    }
  }
`;

export const VERIFY_EMAIL_CODE = gql`
  mutation VerifyEmailCode($code: String!) {
    verifyEmailCode(code: $code) {
      id
      email
    }
  }
`;

export const VERIFY_LOGIN_CODE = gql`
  mutation VerifyLoginCode($email: String!, $code: String!) {
    verifyLoginCode(email: $email, code: $code)
  }
`;
